<template>
    <div class="card rounded-0 mb-3">
        <h3 class="card-header">
            Account Status
        </h3>
        <div class="card-body">
            <div class="alert-warning">{{failureMessage}}</div>
            <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                    <label class="font-weight-bold">
                        Active
                        <i class="fa fa-check ul-red"></i>
                    </label>
                    <a id="delete-account-btn" class="btn btn-dark" href @click.prevent="postForm">Delete Account</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import accountApiClient from '@/services/apiServices/accountApiClient.js'
    import { mapActions } from 'vuex'

    export default {
        name: 'DeletePanel',
        data() {
            return {
                failureMessage: ""
            }
        },
        methods: {
            ...mapActions('oidcStore', [
                'signOutOidcSilent'
            ]),
            postForm: async function () {
                if (confirm('Are you sure you want to delete your account? This action will remove all of your personal information from our system. There will be no way to recover your account once deleted.')) {
                    var value = await accountApiClient.PostDelete();
                    await this.$router.isReady();
                    if (value.status == 200) {
                        if (value.data.success) {
                            this.signOutOidcSilent();
                            this.$store.commit('CANCEL_EXPORT');
                            this.$router.push('ConfirmDelete')
                        } else {
                            this.failureMessage = value.data.message;
                        }
                    } else {
                        this.failureMessage = "Server Interruption"
                    }
                }
            }
        }
    }
</script>

<style scoped>
</style>